import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import { ARTICLE_ID } from '@src/constants/articles';
import Page from '@src/layout-components/page';
import PublicNav from '@src/ui-components/public-nav';
import BattleTerritory from '@src/ui-components/battle-territory';
import ReserveServer from '@src/ui-components/reserve-server';
import WelfareCarnival from '@src/ui-components/welfare-carnival';
import BurdenOptimization from '@src/ui-components/burden-optimization';
import ListStore from './store';
import Link from '@src/components/link';
import $$tracker from '@src/tracker';

const styles = require('./index.less');

const ListPage = () => {
  const store = useStore(() => new ListStore());

  // 单路由 + switch：按当前内页 articleId 渲染对应内页正文（内页只负责自身锚点导航 + CMS 内容）
  const renderArticle = () => {
    switch (store.activeId) {
      case ARTICLE_ID.BATTLE_TERRITORY:
        return <BattleTerritory />;
      case ARTICLE_ID.RESERVE_SERVER:
        return <ReserveServer />;
      case ARTICLE_ID.WELFARE_CARNIVAL:
        return <WelfareCarnival />;
      case ARTICLE_ID.BURDEN_OPTIMIZATION:
        return <BurdenOptimization />;
      default:
        return null;
    }
  };

  // 统一背景 + 公共组件导航上提到页面级，仅渲染一份（跨内页复用，避免每页重复维护/重复渲染背景）：
  // - bg：单张最长背景（bg-upper + bg-under 拼合，1920×16970），顶对齐铺底，页面高度由内页 CMS 内容流式撑开
  // - publicNavSlot：跨内页切换 + 返回首页，activeId 与导航回调统一由本页 store 注入
  return (
    <Page className={styles.root}>
      <div className={styles.bg} data-name={'统一背景'} />
      <div className={styles.topActions}>
        <Link
          className={styles.btnOfficial}
          href="https://jxsj.xoyo.com/index/index.html"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => $$tracker.clickGoWebsite()}
        />
        <Link
          className={styles.btnDownload}
          href="https://jxsj.xoyo.com/index/download.html"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => $$tracker.clickDownload()}
        />
      </div>
      <div className={styles.publicNavSlot}>
        <PublicNav activeId={store.activeId} onNavToList={store.navToList} onBackHome={store.backHome} />
      </div>
      <div className={styles.article}>{renderArticle()}</div>
    </Page>
  );
};

export default observer(ListPage);
